export default __webpack_public_path__ + "static/media/lg_arbitrum.bdf133fe.svg";